import BaseRepository from "@/services/resources/repository";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema);
    }
}

export default Repository;
